import React from 'react';
import styled, { useTheme } from 'styled-components';

import { colors, Theme } from '../../../core';
import Text from '../Text';
import Tooltip from '../Tooltip';

export interface ChipProps {
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium';
  color?: string;
  backGroundColor?: string;
  onClick?: () => void;
  label?: string;
  tooltipId?: string;
  children?: React.ReactNode;
  width?: string;
}

const ChipContainer = styled.div<ChipProps>`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;

  ${({ variant, backGroundColor, theme }) =>
    variant === 'primary' &&
    `
      border-radius: 10px;
      min-width: 120px;
      max-width: 200px;
      height: 20px;
      background-color: ${backGroundColor || theme.chipBackgroundColor || colors.primary};
  
      p {
        padding: 1px 10px ${theme.name === Theme.theme3 ? '3px' : '1px'};
      }
    `}

  ${({ variant, color, backGroundColor, theme, width }) =>
    variant === 'secondary' &&
    `
        display: flex;
        flex-direction: row;
        padding: 0 12px ${theme.name === Theme.theme3 ? '2px' : 0};
        height: 32px;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        min-width: 64px;
        width: ${width || 'auto'};
        background-color: ${
          backGroundColor || `${color}10` || theme.chipBackgroundColor || colors.primary
        };
        border: 1px solid ${color || theme.chipColor || colors.white};

        p {
          line-height: 24px;
          color: ${color || theme.chipColor || colors.white};
          font-size: 14px;
          padding: 0;
        }
    `}
`;

const Chip = ({
  variant = 'primary',
  label,
  color,
  tooltipId,
  children,
  width,
  ...rest
}: ChipProps) => {
  const theme = useTheme();

  return (
    <ChipContainer variant={variant} color={color} width={width} {...rest}>
      {tooltipId && children ? <Tooltip id={tooltipId}>{children}</Tooltip> : null}
      <Text
        data-tip=""
        data-for={tooltipId || ''}
        size="xsmall"
        noMargin
        color={color || theme.chipColor || colors.white}
      >
        {label}
      </Text>
    </ChipContainer>
  );
};

export default Chip;
